// Outlines the top tabs for provider portal
import { Permissions } from './masterdata';

// defaultRoute indicates which route in the drawer we should redirect
// to when that tab is clicked.
export default [
  {
    order: 0,
    anchor: null,
    title: 'Partner',
    drawer: 'partner',
    defaultRoute: 'products',
    permissions: [Permissions.basePartnerAccess],
    hiddenForRoleTypes: ['CompanyOperations'],
  },
  {
    order: 1,
    anchor: {
      route: 'companies',
      target: 'self',
    },
    title: 'Companies',
    // By default, this drawer WILL NOT exist.
    // At a later point in time, when the user has selected
    // a company in the companies tab, the frame will send us
    // the company drawer and it'll be able to connect.
    defaultRoute: 'companies',
    drawer: 'company',
  },
  {
    order: 2,
    title: 'Admin',
    roles: ['SuperAdmin'],
    externalUrl: '/admin.html',
  },
];
